/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_NEW,
  ORDER_STATUS_NONE,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import throwOrderInvalidStatusError from '../../Errors/Order/OrderInvalidStatus.error';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `OrderService`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  AddressSearch: {
    Labels: {
      RemoveAll: `حذف الكل`,
      Search: `ابحث عن عنوان`,
      ToggleAll: `تبديل الكل`,
    },
  },
  CallBoral: ({ contactNumber }) => `مكالمة Boral${contactNumber ? ` (${contactNumber})` : ``}`,
  CallBoralText: `مكالمة Boral`,
  CancelOrderButtonLabel: `إلغاء هذا الطلب`,
  ConcreteDeliveries: {
    ErrorMessage: `خطأ في جلب تفاصيل الطلب`,
    Labels: {
      DeliveredHeader: `تم التوصيل`,
      Docket: `خلاصة`,
      Eta: `الوقت المقدر للوصول`,
      InTransitHeader: `في مرحلة انتقالية`,
      Loading: ({ quantity, isLoading }) => `${quantity}${isLoading ? ` جار التحميل` : ``}`,
      ScheduledHeader: `المقرر`,
      Truck: ({ code, isLoading }) => `شاحنة نقل ${code}${isLoading ? ` جار التحميل` : ``}`,
    },
  },
  ConcreteDeliveriesButtonLabel: `يبني التسليم`,
  ConfirmationOrderButtonLabel: `تأكيد هذا الطلب`,
  NotNowButtonLabel: `لا`,
  OrderCancellation: {
    CompleteMessage: ({ orderCode, title }) => `طلب #${orderCode} إلى ${title} تم إلغاء`,
    ErrorMessages: {
      AfterCutoff: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      AlreadyCancelled: `تم الغاء هذا الطلب. يرجى الاتصال بورال إذا كنت بحاجة إلى إجراء مزيد من التغييرات.`,
      AlreadyConfirmed: `لقد تم تأكيد هذا الطلب بالفعل. يرجى الاتصال بورال إذا كنت بحاجة إلى إجراء مزيد من التغييرات.`,
      BadResponseFromCommand: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      Locked: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      NoResponseFromAPI: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      NoResponseFromCommand: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      TimeoutResponse: `يستغرق طلبك وقتًا أطول من المتوقع. يرجى الاتصال بورال أو المحاولة مرة أخرى في وقت لاحق.`,
    },
    SubTitle: `هل أنت متأكد أنك تريد إلغاء؟`,
    Title: `أنت تلغي`,
  },
  OrderConfirmation: {
    CompleteMessage: ({ orderCode, title }) => `طلب #${orderCode} إلى ${title} تم التاكيد`,
    ErrorMessages: {
      AfterCutoff: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      AlreadyCancelled: `تم الغاء هذا الطلب. يرجى الاتصال بورال إذا كنت بحاجة إلى إجراء مزيد من التغييرات.`,
      AlreadyConfirmed: `لقد تم تأكيد هذا الطلب بالفعل. يرجى الاتصال بورال إذا كنت بحاجة إلى إجراء مزيد من التغييرات.`,
      BadResponseFromCommand: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      Locked: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      NoResponseFromAPI: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      NoResponseFromCommand: `عذرًا ، لا يمكننا معالجة طلبك في الوقت الحالي ، يرجى الاتصال بـ Boral أو إعادة المحاولة لاحقًا.`,
      TimeoutResponse: `يستغرق طلبك وقتًا أطول من المتوقع. يرجى الاتصال بورال أو المحاولة مرة أخرى في وقت لاحق.`,
    },
    SubTitle: `هل أنت متأكد من أنك تريد التأكيد`,
    Title: `أنت تؤكد ذلك`,
  },
  OrderDetails: {
    Code: ({ orderCode }) => `طلب #${orderCode}`,
    ErrorMessage: `خطأ في جلب تفاصيل الطلب`,
    Labels: {
      Date: `تاريخ`,
      DateAndTime: `تاريخ`,
      DeliveryAddress: `عنوان التسليم`,
      DeliverySpacing: `تباعد التسليم`,
      OrderCancelled: `تم الغاء الأمر او الطلب`,
      OrderCode: `رمز الطلب`,
      ProductDetails: `تفاصيل المنتج`,
      PurchaseOrder: `أمر شراء`,
      SiteContactMobile: `الموقع الاتصال المحمول`,
      SpecialInstructions: `تعليمات خاصة`,
      StartTime: `وقت البدء`,
      VolumeOnOrder: `حجم على النظام`,
    },
  },
  QuantityDispatched: ({ quantity, unit }) => `أرسل ${quantity}${unit}`,
  QuantityLabel: `التسليم`,
  QuantityOrdered: ({ quantity, unit }) => `أمر ${quantity}${unit}`,
  QuantityRemaining: ({ quantity, unit }) => {
    const prefix = quantity < 0 ? `بقيادة - برئاسة ` : ``;
    const suffix = quantity >= 0 ? ` متبق` : ``;
    return `${prefix}${Math.abs(quantity)}${unit}${suffix}`;
  },
  ShowAll: `عرض الكل`,
  Status: ({ orderStatus }) => {
    if (orderStatus === ORDER_STATUS_CANCELLED) {
      return `ألغيت`;
    }
    if (orderStatus === ORDER_STATUS_COMPLETED) {
      return `منجز`;
    }
    if (orderStatus === ORDER_STATUS_CONFIRMED) {
      return `تم تأكيد`;
    }
    if (orderStatus === ORDER_STATUS_DELIVERING) {
      return `تقديم`;
    }
    if (orderStatus === ORDER_STATUS_ON_HOLD) {
      return `في الانتظار`;
    }
    if (orderStatus === ORDER_STATUS_TO_BE_CONFIRMED) {
      return `للتأكيد`;
    }
    if (orderStatus === ORDER_STATUS_NONE) {
      return `لا شيء`;
    }
    if (orderStatus === ORDER_STATUS_NEW) {
      return `NEW`;
    }
    return throwOrderInvalidStatusError(orderStatus);
  },
  YesButtonLabel: `نعم فعلا`,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  AddressSearch: {
    Labels: {
      RemoveAll: `Remove All`,
      Search: `Find an address`,
      ToggleAll: `Toggle All`,
    },
  },
  CallBoral: ({ contactNumber }) => `Call Boral${contactNumber ? ` (${contactNumber})` : ``}`,
  CallBoralText: `Call Boral`,
  CancelOrderButtonLabel: `Cancel This Order`,
  ConcreteDeliveries: {
    ErrorMessage: `Error fetching the deliveries details`,
    Labels: {
      DeliveredHeader: `Delivered`,
      Docket: `DOCKET`,
      Eta: `ETA`,
      InTransitHeader: `In Transit`,
      Loading: ({ quantity, isLoading }) => `${quantity}${isLoading ? ` Loading` : ``}`,
      ScheduledHeader: `Scheduled`,
      Truck: ({ code, isLoading }) => `TRUCK ${code}${isLoading ? ` LOADING` : ``}`,
    },
  },
  ConcreteDeliveriesButtonLabel: `Concrete Deliveries`,
  ConfirmationOrderButtonLabel: `Confirm This Order`,
  NotNowButtonLabel: `No`,
  OrderCancellation: {
    CompleteMessage: ({ orderCode, title }) => `Order #${orderCode} to ${title} has been cancelled`,
    ErrorMessages: {
      AfterCutoff: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      AlreadyCancelled: `This order has been cancelled. Please call Boral if you need to make further changes.`,
      AlreadyConfirmed: `This order has already been confirmed. Please call Boral if you need to make further changes.`,
      BadResponseFromCommand: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      Locked: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      NoResponseFromAPI: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      NoResponseFromCommand: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      TimeoutResponse: `Your request is taking longer than expected. Please call Boral or try again later.`,
    },
    SubTitle: `Are you sure you want to cancel?`,
    Title: `You are cancelling for`,
  },
  OrderConfirmation: {
    CompleteMessage: ({ orderCode, title }) => `Order #${orderCode} to ${title} has been confirmed`,
    ErrorMessages: {
      AfterCutoff: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      AlreadyCancelled: `This order has been cancelled. Please call Boral if you need to make further changes.`,
      AlreadyConfirmed: `This order has already been confirmed. Please call Boral if you need to make further changes.`,
      BadResponseFromCommand: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      Locked: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      NoResponseFromAPI: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      NoResponseFromCommand: `Sorry we are not able to process your request at this time, please call Boral or try again later.`,
      TimeoutResponse: `Your request is taking longer than expected. Please call Boral or try again later.`,
    },
    SubTitle: `Are you sure you want to confirm?`,
    Title: `You are confirming for`,
  },
  OrderDetails: {
    Code: ({ orderCode }) => `Order ${orderCode}`,
    ErrorMessage: `Error fetching the order details`,
    Labels: {
      Date: `Date`,
      DateAndTime: `Date`,
      DeliveryAddress: `Delivery Address`,
      DeliverySpacing: `Delivery Spacing`,
      OrderCancelled: `Order Cancelled`,
      OrderCode: `Order Code`,
      ProductDetails: `Product Details`,
      ProjectName: `Project Name`,
      PurchaseOrder: `Purchase Order`,
      SiteContactMobile: `Site Contact Mobile`,
      SpecialInstructions: `Special Instructions`,
      StartTime: `Start Time`,
      VolumeOnOrder: `Volume on Order`,
    },
  },
  QuantityDispatched: ({ quantity, unit }) => `${quantity}${unit} dispatched`,
  QuantityLabel: `Deliveries`,
  QuantityOrdered: ({ quantity, unit }) => `${quantity}${unit} ordered`,
  QuantityRemaining: ({ quantity, unit }) => {
    const prefix = quantity < 0 ? `Over by ` : ``;
    const suffix = quantity >= 0 ? ` remaining` : ``;
    return `${prefix}${Math.abs(quantity)}${unit}${suffix}`;
  },
  ShowAll: `Show All`,
  Status: ({ orderStatus }) => {
    if (orderStatus === ORDER_STATUS_CANCELLED) {
      return `Cancelled`;
    }
    if (orderStatus === ORDER_STATUS_COMPLETED) {
      return `Completed`;
    }
    if (orderStatus === ORDER_STATUS_CONFIRMED) {
      return `Confirmed`;
    }
    if (orderStatus === ORDER_STATUS_DELIVERING) {
      return `Delivering`;
    }
    if (orderStatus === ORDER_STATUS_ON_HOLD) {
      return `On Hold`;
    }
    if (orderStatus === ORDER_STATUS_TO_BE_CONFIRMED) {
      return `To Be Confirmed`;
    }
    if (orderStatus === ORDER_STATUS_NONE) {
      return `None`;
    }
    if (orderStatus === ORDER_STATUS_NEW) {
      return `NEW`;
    }
    return throwOrderInvalidStatusError(orderStatus);
  },
  YesButtonLabel: `Yes`,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  AddressSearch: {
    Labels: {
      RemoveAll: `移除所有`,
      Search: `查找地址`,
      ToggleAll: `全部切换`,
    },
  },
  CallBoral: ({ contactNumber }) => `呼叫 Boral${contactNumber ? ` (${contactNumber})` : ``}`,
  CallBoralText: `呼叫 Boral`,
  CancelOrderButtonLabel: `取消此订单`,
  ConcreteDeliveries: {
    ErrorMessage: `获取订单详细信息时出错`,
    Labels: {
      DeliveredHeader: `交付`,
      Docket: `案卷`,
      Eta: `预计到达时间`,
      InTransitHeader: `在途中`,
      Loading: ({ quantity, isLoading }) => `${quantity}${isLoading ? ` 装载` : ``}`,
      ScheduledHeader: `计划`,
      Truck: ({ code, isLoading }) => `卡车 ${code}${isLoading ? ` 装载` : ``}`,
    },
  },
  ConcreteDeliveriesButtonLabel: `水泥 交付`,
  ConfirmationOrderButtonLabel: `確認此訂單`,
  NotNowButtonLabel: `沒有`,
  OrderCancellation: {
    CompleteMessage: ({ orderCode, title }) => `订购 #${orderCode} 至 ${title} 已经被取消`,
    ErrorMessages: {
      AfterCutoff: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      AlreadyCancelled: `订单已被取消。如果您需要进一步更改，请致电Boral。`,
      AlreadyConfirmed: `此订单已经确认。如果您需要进一步更改，请致电Boral。`,
      BadResponseFromCommand: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      Locked: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      NoResponseFromAPI: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      NoResponseFromCommand: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      TimeoutResponse: `您的要求比预期的要长。请致电Boral或稍后再试。`,
    },
    SubTitle: `你确定要取消？`,
    Title: `你要取消了`,
  },
  OrderConfirmation: {
    CompleteMessage: ({ orderCode, title }) => `订购 #${orderCode} 至 ${title} 已经确认`,
    ErrorMessages: {
      AfterCutoff: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      AlreadyCancelled: `订单已被取消。如果您需要进一步更改，请致电Boral。`,
      AlreadyConfirmed: `此订单已经确认。如果您需要进一步更改，请致电Boral。`,
      BadResponseFromCommand: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      Locked: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      NoResponseFromAPI: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      NoResponseFromCommand: `抱歉，我们目前无法处理您的请求，请致电Boral或稍后再试。`,
      TimeoutResponse: `您的要求比预期的要长。请致电Boral或稍后再试。`,
    },
    SubTitle: `您確定要確認嗎？`,
    Title: `你正在确认`,
  },
  OrderDetails: {
    Code: ({ orderCode }) => `订购 #${orderCode}`,
    ErrorMessage: `获取订单详细信息时出错`,
    Labels: {
      Date: `日期`,
      DateAndTime: `日期`,
      DeliveryAddress: `邮寄地址`,
      DeliverySpacing: `交货间距`,
      OrderCancelled: `订单已取消`,
      OrderCode: `订单代码`,
      ProductDetails: `产品详情`,
      PurchaseOrder: `采购订单`,
      SiteContactMobile: `网站联系移动`,
      SpecialInstructions: `特殊说明`,
      StartTime: `开始时间`,
      VolumeOnOrder: `订单量`,
    },
  },
  QuantityDispatched: ({ quantity, unit }) => `${quantity}${unit} 出动`,
  QuantityLabel: `交付`,
  QuantityOrdered: ({ quantity, unit }) => `${quantity}${unit} 有序`,
  QuantityRemaining: ({ quantity, unit }) => {
    const prefix = quantity < 0 ? `过了 ` : ``;
    const suffix = quantity >= 0 ? ` 其余` : ``;
    return `${prefix}${Math.abs(quantity)}${unit}${suffix}`;
  },
  ShowAll: `显示所有`,
  Status: ({ orderStatus }) => {
    if (orderStatus === ORDER_STATUS_CANCELLED) {
      return `取消`;
    }
    if (orderStatus === ORDER_STATUS_COMPLETED) {
      return `已完成`;
    }
    if (orderStatus === ORDER_STATUS_CONFIRMED) {
      return `确认`;
    }
    if (orderStatus === ORDER_STATUS_DELIVERING) {
      return `交付`;
    }
    if (orderStatus === ORDER_STATUS_ON_HOLD) {
      return `等候接听`;
    }
    if (orderStatus === ORDER_STATUS_TO_BE_CONFIRMED) {
      return `待确认`;
    }
    if (orderStatus === ORDER_STATUS_NONE) {
      return `没有`;
    }
    if (orderStatus === ORDER_STATUS_NEW) {
      return `NEW`;
    }
    return throwOrderInvalidStatusError(orderStatus);
  },
  YesButtonLabel: `是`,
});
